<template>
  <div>
    <div id="footer">
      <div class="main">
        <div class="siteinfo">
          <p>
            Copyright © 2011-2018 Limited All Rights Reserved. 贵州广播电视台版权所有。
            <a href="/">联系我们</a>
          </p>
          <p>贵州广播电视台 版权所有 黔ICP备13001066号-1 贵阳公安网监备案 GYBA-第2919号</p>
          <p>信息网络传播视听节目许可证号 2410521</p>
          <p>互联网新闻信息服务许可证号 52120170005</p>
          <p>
            <a href="/">黔ICP备13001066号-1 贵阳公安网监备案 GYBA-第2919号</a>
            <a href="/">
              <img
                style="height: 18px;width: 18px;display: inline-block"
                src="https://images.v2gogo.com/image/2020/05/13/e951d530afb44a60aa010f4da81d7dfe.png"
              >贵公网安备 52010202000344号
            </a>
          </p>
          <a
            href="/"
          >
            <img
              class="icon"
              :src="cfg.ossDomain + '/shiyedanwei.png'"
              alt
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Foot',
  data() {
    return {
    };
  },
  created: function() {
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
#footer {
  background: #4A83B5;
  background-size: cover;
  color: #fff;
  line-height: 30px;
  overflow: hidden;
  font-size: 12px;
  font-family: å®‹ä½“;
  padding: 30px 0;
  margin-top: 80px;
}
#footer .main .siteinfo {
  margin: 0 auto;
  width: 1200px;
  display: flex;
  flex-direction: column;
  vertical-align: middle;
  text-align: center;
  overflow: hidden;
}
@media screen and (max-width: 768px) {
  #footer .main .siteinfo {
    width: 100%;
    max-width: 100%;
    padding: 0 10px;
  }
}
#footer a {
  color: #f3f3f3;
  font-size: 12px;
}
a {
  text-decoration: none;
  color: #484848;
}
a:hover,
a:focus {
  text-decoration: underline;
}
.icon{
  margin-top: 22px;
  width: 55px;
  height: 68px;
}
// .foot-box {
//   width: 100%;
//   min-width: 1200px;
//   background: #367dbe;

//   footer {
//     width: 1200px;
//     height: 145px;
//     text-align: center;
//     box-sizing: border-box;
//     padding: 10px 0;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: space-around;
//     p {
//       font-size: 12px;
//       color: #fff;
//     }
//     p:nth-child(1) {
//       font-size: 14px;
//     }
//   }
// }
</style>
